export default __webpack_public_path__ + "static/media/photo--lg--christina-1.e2007082.jpg";